import React from "react";

export const ToDoContext = React.createContext({
  todos: [],
});
